import { CUSTOMER_NEEDS } from '@ahmdigital/constants';
import { getOr } from 'lodash/fp';
import React from 'react';

import { SHORT_PAGE_TITLE_TEMPLATE } from '../../../../ahm-constants/ui';
import getTitleFromType from '../../../../utils/get-title-from-type';
import Head from '../../../../../utils/head';

// @ts-expect-error - Automatic, Please fix when editing this file
const getTitleForNeeds = ({ needsProductType, needsType, productType }) =>
  `Health insurance ${getTitleFromType({ needsProductType, needsType, productType })}`;

const DEFAULT_DESCRIPTION = `Compare ahm’s hospital and extras packages. We’ve got your back with a range of private health insurance options and plans to suit your needs.`;

const metaDescriptionOverride = {
  [CUSTOMER_NEEDS.EXTRAS_COVER]: {
    [CUSTOMER_NEEDS.ALL]: {
      description:
        'Compare extras insurance cover options for services like dental, physio, optical & ambulance, plus more! View the full range here. Buy online today.',
      titleSuffix: 'Extras only',
    },
  },
  [CUSTOMER_NEEDS.HOSPITAL_COVER]: {
    [CUSTOMER_NEEDS.ALL]: {
      description:
        'Compare hospital cover options, find the best hospital cover for you. Options and control in case of in-hospital treatments, including elective surgeries and medical surgeries.',
      titleSuffix: 'Hospital only',
    },
  },
};

type ProductListingHeadProps = {
  needsProductType?: string;
  needsType: string;
  productType: string;
};

const ProductListingHead = ({ needsProductType, needsType, productType }: ProductListingHeadProps) => {
  const metaDescription = getOr(
    DEFAULT_DESCRIPTION,
    `${needsType}.${needsProductType}.description`,
    // @ts-expect-error - Automatic, Please fix when editing this file
  )(metaDescriptionOverride);

  const needsTitle = getTitleForNeeds({ needsProductType, needsType, productType });
  // @ts-expect-error - Automatic, Please fix when editing this file
  const titleSuffix = getOr('', `${needsType}.${needsProductType}.titleSuffix`)(metaDescriptionOverride);
  const metaTitle = titleSuffix ? `${needsTitle} plans & ${titleSuffix}` : needsTitle;

  return (
    <Head titleTemplate={SHORT_PAGE_TITLE_TEMPLATE}>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
    </Head>
  );
};

ProductListingHead.defaultProps = {
  needsProductType: '',
};

export default ProductListingHead;
